// extracted by mini-css-extract-plugin
module.exports = {"searchSection":"styles_searchSection__vLjTO","searchInputContainer":"styles_searchInputContainer__H7Tx_"};